import { render, staticRenderFns } from "./PasajeCreate.vue?vue&type=template&id=61d1502c"
import script from "./PasajeCreate.vue?vue&type=script&lang=js"
export * from "./PasajeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports